import { useState } from "react";

const faqs = [
  {
    question: "1. What is Jopo Driver?",
    answer:
      "Jopo Delivery Driver is the partner app that allows drivers to earn income by delivering parcels. You receive delivery requests, complete trips, and get paid directly through the platform."
  },
  {
    question: "2. How do I become a Jopo driver?",
    answer: `To join:
- Download the Jopo Driver app
- Register with your personal details
- Upload required documents (ID, license, vehicle details, Letter from the government office)
- Vehicle registration
- Complete verification
- Get approved and start earning`
  },
  {
    question: "3. What documents are required?",
    answer: `You'll need:
- Valid driver's license
- National ID or passport
- Vehicle registration documents
- Insurance (Must)`
  },
  {
    question: "4. How do I receive delivery requests?",
    answer: `- Requests are sent through the app
- You can accept or reject
- Once accepted, you'll see pickup and drop-off details`
  },
  {
    question: "5. How are driver earnings calculated?",
    answer: `Earnings depend on:
- Number of completed deliveries
- Distance covered
- Delivery type (single, bulk, multi-drop)
- Bonuses (e.g., completing 5 deliveries = reward)`
  },
  {
    question: "6. What happens if I don't complete all assigned deliveries?",
    answer: `Jopo supports partial completion logic:
- You earn proportionally for completed trips
- Bonus applies only if full target is reached
- Example: 3 out of 5 trips → base earnings only (no bonus)`
  },
  {
    question: "7. How and when do I get paid?",
    answer: `Payments are made via:
- Mobile money (Bank transfer, M-Pesa, Airtel Money, etc.)
- Weekly or daily payouts (based on system setup)
- In-app wallet tracking`
  },
  {
    question: "8. Do I need to pay to use the app?",
    answer: `Yes (based on your business model):
- Monthly / quarterly / yearly subscription
- Access to delivery requests depends on active subscription`
  },
  {
    question: "9. Can I choose my working hours?",
    answer: `Yes:
- Work anytime (flexible schedule)
- Go online/offline anytime`
  },
  {
    question: "10. What happens if I cancel a delivery?",
    answer: `- Frequent cancellations may affect your rating
- Penalties may apply
- Customers expect reliability`
  },
  {
    question: "11. How do I navigate to delivery locations?",
    answer: `The app provides:
- Built-in maps
- Real-time navigation
- Optimized routes`
  },
  {
    question: "12. What if I face issues during delivery?",
    answer: `You can:
- Contact support via the app
- Report issues (customer unavailable, wrong address, etc.)
- Get assistance in real-time`
  },
  {
    question: "13. How is delivery confirmed?",
    answer: `Delivery is verified using:
- OTP from customer
- Signature or photo proof
- Status update in app`
  },
  {
    question: "14. How does the rating system work?",
    answer: `- Customers rate drivers after delivery
- High ratings = more job opportunities
- Low ratings may reduce visibility`
  },
  {
    question: "15. What items am I allowed to deliver?",
    answer: `Allowed:
- Parcels, packages, documents

Not allowed:
- Illegal or dangerous items
- Restricted goods`
  },
  {
    question: "16. What happens if a customer is not available?",
    answer: `- Try contacting the customer
- Wait for a defined time
- Report in app
- Follow return or re-delivery instructions`
  },
  {
    question: "17. Can I handle multiple deliveries at once?",
    answer: `Yes:
- Jopo assigns batch deliveries (e.g., 5 trips per route)
- Optimized routing increases your earnings`
  },
  {
    question: "18. Is there support for fuel or expenses?",
    answer: `Depending on program:
- Incentives or bonuses may be provided
- Efficiency is key to maximizing earnings`
  },
  {
    question: "19. What happens if my account is suspended?",
    answer: `- Suspension may occur due to policy violations
- You’ll be notified with reasons
- You can appeal through support`
  },
  {
    question: "20. How can I increase my earnings?",
    answer: `- Complete more deliveries
- Maintain high ratings
- Avoid cancellations
- Work during peak hours
- Complete full delivery batches (to earn bonuses)`
  }
];

export default function DriverFAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold text-orange-600 mb-6">
        Driver FAQs
      </h1>

      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border border-gray-200 rounded-xl shadow-sm"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex justify-between items-center p-4 text-left font-semibold text-green-700 hover:bg-green-50 rounded-xl"
            >
              {faq.question}
              <span className="text-orange-500 text-xl">
                {openIndex === index ? "-" : "+"}
              </span>
            </button>

            {openIndex === index && (
              <div className="p-4 pt-0 text-gray-700 whitespace-pre-line">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}